var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.75 22H18.25C17.5596 22 17 22.5596 17 23.25V43.25C17 43.9404 17.5596 44.5 18.25 44.5H45.75C46.4404 44.5 47 43.9404 47 43.25V23.25C47 22.5596 46.4404 22 45.75 22Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.25 22V19.5C38.25 18.837 37.9866 18.2011 37.5178 17.7322C37.0489 17.2634 36.413 17 35.75 17H28.25C27.587 17 26.9511 17.2634 26.4822 17.7322C26.0134 18.2011 25.75 18.837 25.75 19.5V22",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29.5V37",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.75 33.25H28.25",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.202264ecc1de8dbb0fab8b0168ec2189.svg";
export { ForwardRef as ReactComponent };